import { Injectable } from "@angular/core";
import { ConfigurationService } from "app/core/config/configuration.service";
import { HttpClientMaster } from "app/core/http/http-client-master";
import { ResponseForm } from "app/core/models/response-form.model";
import { UriUtils } from "app/core/utils/uri.utils";
import { map, Observable } from "rxjs";
import { BiAlertNotification } from "../models/bi-alert-notification.model";
import { BiAlert } from "../models/bi-alert.model";
import { FindAlertsRequest } from "../models/filter/find-alert-request.model";
import { PageableResponse } from "../models/pageable-response";


@Injectable({
    providedIn: "root"
})
export class BIAlertService {
    constructor(private _httpClient: HttpClientMaster, private _configService: ConfigurationService) {}

    findById(id: string): Observable<BiAlert> {
        return this._httpClient.get<BiAlert>(this.buildUrlAlertModule(`/${id}`));
    }

    findAllAlertTypes(): Observable<string[]> {
        return this._httpClient.get<string[]>(this.buildUrlAlertModule("/types"));
    } 

    findAllMedias(): Observable<string[]> {
        return this._httpClient.get<string[]>(this.buildUrlAlertModule("/medias"));
    } 

    findUnreadAlerts(): Observable<PageableResponse<BiAlert>> {
        return this._httpClient.post<PageableResponse<BiAlert>>(this.buildUrlAlertModule('/unreadAlertsSimple'), {});
    }

    findAlerts(request: FindAlertsRequest): Observable<PageableResponse<BiAlert>> {
        return this._httpClient.post<PageableResponse<BiAlert>>(this.buildUrlAlertModule('/findAlerts'), request);
    }

    markAlertAsRead(idAlert: string): Observable<BiAlert> {
        return this._httpClient.put<BiAlert>(this.buildUrlAlertModule(`/read/${idAlert}`), {});
    }

    markAllAlertsAsRead(): Observable<void> {
        return this._httpClient.put<void>(this.buildUrlAlertModule(`/markAllAsRead`), {});
    }

    deleteAlert(idAlert: string): Observable<void> {
        return this._httpClient.delete<void>(this.buildUrlAlertModule(`/${idAlert}`));
    }

    findNotificationConfigByUser(userId: number): Observable<ResponseForm<BiAlertNotification>> {
        return this._httpClient.get<ResponseForm<BiAlertNotification>>(this.buildUrl(`/config/${userId}`));
    }

    saveNotificationConfig(config: BiAlertNotification): Observable<ResponseForm<void>> {
        return this._httpClient.post<ResponseForm<void>>(this.buildUrl('/saveConfig'), config);
    }

    updateNotificationConfig(config: BiAlertNotification): Observable<ResponseForm<void>> {
        return this._httpClient.post<ResponseForm<void>>(this.buildUrl('/updateConfig'), config);
    }

    deleteNotificationConfigByUser(userId: number): Observable<ResponseForm<void>> {
        return this._httpClient.delete<ResponseForm<void>>(this.buildUrl(`/deleteConfig/${userId}`));
    }

    downloadReport(alertId: string, lang: string): Observable<{fileName: string, blob: Blob }> {
        const rootUrl = this._configService.getConfig().biAlertUrl;
        return this._httpClient.get(`${rootUrl}/report/${alertId}/${lang}`, {
            responseType: 'blob',
            observe: 'response'
        })
        .pipe(
            map(response => {
                const fileName = response.headers.get('Content-Disposition')?.split('filename=')[1] || 'report.pdf';
                const blob = new Blob([response.body], { type: response.headers.get('Content-Type') || 'application/pdf' });
                return {
                    fileName,
                    blob
                };
            })
        );
    }

   

    private buildUrl(...segments: string[]): string {
        return UriUtils.appendParts(this._configService.getConfig().rootUrl, "/bi-alert", ...segments);
    }

    private buildUrlAlertModule(...segments: string[]): string {
        return UriUtils.appendParts(this._configService.getConfig().biAlertUrl, "/alert", ...segments);
    }
}